"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModalLightbox;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _react = _interopRequireWildcard(require("react"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
  * Modal Lightbox Component
  * Render modal CTAs (primary merch button, secondary merch button, auto load, paragraph link, inline link)
  * @module ModalLightbox
  * @param {String} design UXCore Button design (primary, secondary, inline link, etc)
  * @param {Object} content Content of the modal when opened (headline lockup should be main use)
  * @param {string} _name Sitecore item name for tracking
  * @param {Boolean} isPromo Use promo (default) or eid
  * @param {String} ariaLabel UXCore Button props
  * @param {string} id The id as required by ux2200 modal
  * @param {string} text Button text that triggers modal lightbox
  * @param {Boolean} isAutoLoad Auto load modal on page load
  * @param {Modal.propTypes} modalProps Modal props
  *
  **/

function ModalLightbox({
  id,
  text,
  design,
  content,
  _name,
  isPromo = true,
  ariaLabel,
  launchOnLoad = false,
  ...modalProps
}) {
  const [visible, setVisibility] = (0, _react.useState)(launchOnLoad);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, (0, _extends2.default)({
    design: design,
    text: text,
    onClick: () => setVisibility(true)
  }, _patternLibraryUtils.tracking.create(_name, true, isPromo), {
    "aria-label": ariaLabel,
    "data-cy": "modal-button"
  })), visible && /*#__PURE__*/_react.default.createElement(_modal.default, (0, _extends2.default)({
    "data-cy": "modal",
    id: `modal-${id}`,
    onClose: () => setVisibility(false)
  }, modalProps), /*#__PURE__*/_react.default.isValidElement(content) ? (/*#__PURE__*/_react.default.cloneElement(content)) : /*#__PURE__*/_react.default.createElement(_index.default, content)));
}
ModalLightbox.propTypes = {
  id: _propTypes.default.string,
  text: _propTypes.default.string,
  design: _propTypes.default.string,
  content: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  _name: _propTypes.default.string,
  isPromo: _propTypes.default.bool,
  ariaLabel: _propTypes.default.string,
  launchOnLoad: _propTypes.default.bool,
  ..._modal.default.propTypes
};